module.exports = "/_next/static/images/winit-fade-logo-9f5c4ac098fa3acb1f58622045a9e964.png";